<template>
    <div id="map-posts">

        <ais-stats>
            <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">

                <!-- No Results -->
                <div class="map-post no-results" v-if="!nbHits">
                    <p class="map-list-empty">
                        No Results
                    </p>
                </div>

                <!-- List of Spots -->
                <div v-else>
                    <div class="map-post"
                         v-for="spot in spots"
                         :about="spot.id"
                         :id="`map-post-${spot.id}`"
                         :key="`spot-place-${spot.id}-${spot.slug}`"
                         @mouseover="onMouseOverSpot(spot)"
                         @touchstart="setCurrentSpot(spot)"
                         @mouseout="smallPin(spot)">

                        <small v-if="spot.is_new">New</small>

                        <!-- Save spot in your list -->
                        <span v-if="isAuth"
                              class="post-wishlist-button list-add-trigger"
                              :data-id="spot.id" :data-title="spot.title">
                        <svg class="save"><use xlink:href="#save"></use></svg>
                    </span>

                        <span v-else
                              class="post-wishlist-button"
                              data-modal="apply">
                        <svg class="save"><use xlink:href="#save"></use></svg>
                    </span>

                        <div v-if="!isAuth" class='map-post__slider single'>
                            <div class="slides">
                                <a :href="`/${spot.city.slug}/${spot.slug}`">
                                    <img :src="spot.images[0]" loading="lazy">
                                </a>
                            </div>
                        </div>

                        <map-spot-slider v-else-if="spot.hasOwnProperty('images')" :spot="spot"></map-spot-slider>

                        <div class="content">

                            <!-- Spot Category -->
                            <h3 :class="`cat-${spot.category.slug}`">
                                <a :href="`/destination/${spot.city.slug}/browse?category=${spot.category.slug}`"
                                   v-text="spot.category.title">
                                </a>
                            </h3>

                            <!-- Spot Title -->
                            <h2>
                                <a :href="`/${spot.city.slug}/${spot.slug}`"
                                   v-text="spot.name">
                                </a>
                            </h2>

                            <!-- Tags -->
                            <div class="main-tags">
                                <h4>
                        <span class="sub-cat" v-if="spot.subcategory">
                            {{ spot.subcategory.title ?  spot.subcategory.title : ''  }}
                        </span>
                                    <span v-if="spot.subcategory">in</span>
                                    <a  v-if="spot.neighborhood"
                                        :href="`/destination/${spot.city.slug}/browse?neighborhoods=${spot.neighborhood.slug}`"
                                        v-text="spot.neighborhood.title">
                                    </a>
                                    <a v-if="spot.neighborhood"
                                       :href="`/destination/${spot.city.slug}`"
                                       v-text="spot.city.title">
                                    </a>
                                </h4>
                            </div>

                            <div class="extra-tags">

                                <!-- Price Tooltips -->
                                <p class="price-value" v-if="spot.price">
                        <span class="price-tooltip alt">
                                <p v-text="spot.price_tooltips_text"></p>
                                <span v-text="spot.price_rate_tooltips_text"></span>
                                </span>
                                <span v-text="repeatString('$', spot.price)"></span>
                                <span v-text="repeatString('$', (4 - spot.price))"></span>
                                </p>

                                <!-- Tags -->
                                <span v-for="tag in limitTags(spot.tags, 2)" v-text="tag"></span>
                            </div>

                        </div>

                    </div>
                </div>

            </template>
        </ais-stats>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import MapLoading from '@/components/Cities/MapLoading'
import MapSpotSlider from "@/components/SpotSlider";

export default {

    mixins: [Helpers],

    props: ['city', 'spots'],

    components: {
        MapLoading,
        MapSpotSlider,
        VueSlickCarousel
    },

    data() {
        return {
        };
    },

    created() {
        eventBus.$on("moveScrollToSpot", event => this.moveScrollToSpot(event));
    },

    methods: {

        onMouseOverSpot(spot) {
            if (this.isMobile) return
            eventBus.$emit("markerBigger", spot);
        },

        setCurrentSpot(spot) {
            // TODO
        },

        smallPin(spot) {
            eventBus.$emit("markerSmall", spot);
        },

        limitTags(tags, take){
            return _.take(tags, take)
        },

        moveScrollToSpot(spotId) {
            var headerHight = $(".main-header").outerHeight();
            let scrollTo = $("#map-post-" + spotId).offset().top - headerHight - 85;
            $("html, body").animate({
                scrollTop: scrollTo
            })
        },
    },
}
</script>
<style lang="scss">
.loading-more-spots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.25rem;
    border-radius: 32px;
    text-align: center;
    color: #333;
    font-size: 13px;
    margin-bottom: 2rem;
    font-family: "Plantin", serif;

    .icon-star {
        animation-name: spin;
        animation-duration: 5000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        margin-right: 10px;
        width: 20px;
        height: 20px;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
